import axios from '@/api/utils/legacy-axios-helper';

/**
 * 獲取學生教室列表 (Legacy API)
 * GET /student/classrooms/legacy
 * @param {Object} params - 查詢參數
 * @param {number} [params.page=1] - 頁碼
 * @param {number} [params.pagesize=10] - 每頁筆數
 * @returns {Promise} API 回應
 */
const getLegacyClassrooms = async(params = {}) => {
  const defaultParams = {
    page: 1,
    pagesize: 10,
    ...params,
  };

  const response = await axios({
    url: '/student/classrooms/legacy',
    method: 'get',
    params: defaultParams,
    responseType: 'json',
    headers: { 'Cache-Control': 'no-cache' },
  });

  return response;
};

export { getLegacyClassrooms };
